<p aria-atomic="true" aria-live="polite" class="sr-only" role="status">
    @if (state().loading) {
        {{ 'UI.ACCESSIBILITY.LOADING' | translate }}
    }
</p>

<div
    #layerEl
    class="fixed inset-0 size-full border-0 bg-transparent p-0"
    popover="manual"
>
    @if (state().loading) {
        <div
            class="flex h-full items-center justify-center"
            [ngClass]="{
                'bg-dialog-layer': state().content.blackBackground,
            }"
        >
            <div class="flex flex-col items-center space-y-16 text-text-white">
                <interacta-image class="w-100" [alt]="''" [src]="imageSrc()" />

                <div class="flex typo-medium">
                    @let text = (text$() | async) ?? '';
                    <span>{{
                        (text | translate: state().content.translateParams) ||
                            '&nbsp;'
                    }}</span>

                    <p class="w-14">
                        @for (
                            point of (points$ | async) || 0 | array;
                            track $index
                        ) {
                            <span
                                [ngClass]="{
                                    'mx-4': $first,
                                    'mr-4': !$first && !$last,
                                }"
                                >.</span
                            >
                        }
                    </p>
                </div>
                @let secondaryText = secondaryText$ | async;
                <p class="typo-sm">
                    @if (secondaryText) {
                        {{ secondaryText | translate }}
                    } @else {
                        &nbsp;
                    }
                </p>
            </div>
        </div>
    }
</div>
